import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import { useCountdown } from "usehooks-ts";
import ToggleButton from "../ToggleButton/ToggleButton";

/**
 * This function returns the {@link TimerView} `component`
 *
 * @param props recieve `Props`
 * @returns `Element`
 */

export const TimerView = forwardRef((props, ref) => {
  const { closeExam } = props;
  const [count, { startCountdown, stopCountdown, resetCountdown }] =
    useCountdown({
      countStart: 60 * 20,
      intervalMs: 1000,
    });
  const [timerOn, setTimerOn] = useState(true);

  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, () => ({
    startTimer() {
      if (timerOn) {
        startCountdown();
      }
    },
    stopTimer() {
      stopCountdown();
    },
    resetTimer() {
      resetCountdown();
    },
  }));

  useEffect(() => {
    if (count === 0) {
      closeExam();
    }
  }, [count, closeExam]);

  let minutes = Math.floor(count / 60);
  return (
    <div className="tempo_box">
      <div className="tempo_btn">
        <span>Tempo</span>
        <ToggleButton
          onSwitch={() => {
            if (timerOn) {
              setTimerOn(false);
              stopCountdown();
            } else {
              setTimerOn(true);
              startCountdown();
            }
          }}
          isActive={timerOn}
        />
      </div>
      <div className="tempo">
        <span>TEMPO A DISPOSIZIONE</span>
        <span>{`${minutes}:${count - minutes * 60}`}</span>
      </div>
    </div>
  );
});

export default TimerView;
